import { styled as floraStyled } from '@grupoboticario/flora-react';
import { mixins, styled, theme, utils } from 'ui/theme';

export const Progress = {
  Component: floraStyled('div', {
    display: 'flex',
    gap: '$2',
    width: '100%',
  }),

  Circle: styled.svg`
    height: 100%;
    width: 100%;

    circle {
      ${utils.transition('stroke-dashoffset').easing('easeInOut').duration('short')};
      fill: transparent;
      stroke: ${theme.colors.build.mediumLight2};
      stroke-width: ${theme.space[1]};
      transform: rotate(-90deg);
      transform-origin: 50% 50%;
    }

    text {
      ${mixins.baseFont};
      font-size: ${theme.fontSizes.md};
      fill: ${theme.colors.build.darkLight};
    }

    &[data-size='medium'] {
      circle {
        stroke-width: ${theme.space[2]};
      }
    }
    &[data-size='large'] {
      circle {
        stroke-width: ${theme.space[3]};
      }
    }

    &[data-reverse='true'] {
      circle {
        transform: rotate(-90deg) scaleY(-1);
      }
    }

    &[data-color='primary'] {
      circle {
        &:nth-of-type(2) {
          stroke: ${theme.colors.build.mediumLight1};
        }
      }
    }

    &[data-color='secondary'] {
      circle {
        &:nth-of-type(2) {
          stroke: ${theme.colors.build.brand2};
        }
      }
    }

    &[data-color='tertiary'] {
      circle {
        &:nth-of-type(2) {
          stroke: ${theme.colors.build.brand3};
        }
      }
    }

    &[data-color='success'] {
      circle {
        &:nth-of-type(2) {
          stroke: ${theme.colors.status.success.standard};
        }
      }
    }

    &[data-color='error'] {
      circle {
        &:nth-of-type(2) {
          stroke: ${theme.colors.status.error.standard};
        }
      }
    }

    &[data-color='alert'] {
      circle {
        &:nth-of-type(2) {
          stroke: ${theme.colors.status.alert.standard};
        }
      }
    }
  `,

  Info: floraStyled('div', {
    color: '$backgroundAltSecondary',
    display: 'block',
    textAlign: 'center',
    width: '100%',
  }),

  Range: floraStyled('progress', {
    appearance: 'none',
    height: '$1',
    isolation: 'isolate',
    width: '100%',
    position: 'relative',
    '&[value]::-webkit-progress-bar': {
      background: '$nonInteractiveAltAuxiliar',
      borderRadius: '$large',
    },

    '&[value]::-webkit-progress-value': {
      background: '$nonInteractiveEmphasis',
      borderRadius: '$large',
    },

    '&::after': {
      color: '$buildLightDark2',
      left: '50%',
      margin: '$0',
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },

    '&[data-color="primary"]': {
      background: '$nonInteractiveAltAuxiliar',
    },

    '&[data-color="secondary"]': {
      background: '$nonInteractiveAltAuxiliar',
    },

    '&[data-color="tertiary"]': {
      background: '$backgroundAltTertiary',
    },

    '&[data-color="success"]': {
      background: '$statusSuccessActionableAlt',
    },

    '&[data-color="error"]': {
      background: '$statusErrorActionableAlt',
    },

    '&[data-color="alert"]': {
      background: '$statusAlertActionableAlt',
    },

    '&[data-size="medium"]': {
      borderRadius: '$3',
      height: '$3',

      '&[value]::-webkit-progress-bar, &[value]::-webkit-progress-value': {
        borderRadius: '$3',
      },

      '&[data-showlabel="true"]': {
        '&::after': {
          content: 'attr(data-label)',
          fontSize: '$exceptionsAuxiliar',
        },
      },
    },

    '&[data-size="large"]': {
      borderRadius: '$6',
      height: '$6',

      '&[value]::-webkit-progress-bar, &[value]::-webkit-progress-value': {
        borderRadius: '$6',
      },

      '&[data-showlabel="true"]': {
        '&::after': {
          content: 'attr(data-label)',
        },
      },
    },
  }),
};
